import CompanyEdit from './CompanyEdit'

export default CompanyEdit;